import { Theme } from '@mui/material/styles';

export const getBaseDialogStyles = (theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    background: '#2e194b',
    color: '#fff',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

export const getCustomerSelectorStyles = (theme: Theme) => ({
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  selectList: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  selectListPanel: {
    margin: `${theme.spacing(1)} 0`,
    width: '100%',
    boxSizing: 'border-box',
  },
  modalSelector: {
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    width: '100%',
  },
  search: {
    position: 'relative',
    borderRadius: `${theme.shape.borderRadius}px`,
    borderColor: 'black',
    backgroundColor: 'white',
    width: '100%',
  },
  table: {
    cursor: 'pointer',
  },
});

export const getSiteSelectorStyles = (theme: Theme) => ({
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  selectList: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  selectListPanel: {
    margin: `${theme.spacing(1)} 0`,
    width: '100%',
    boxSizing: 'border-box',
  },
  modalSelector: {
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    width: '100%',
  },
});

export const getUploadStyles = (theme: Theme) => ({
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    padding: 0,
  },
  errMsg: {
    color: 'red',
    marginTop: theme.spacing(2),
  },
  successMsg: {
    color: 'green',
    marginTop: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  fileUpload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#e3e8ea',
    height: '30vh',
    border: '2px dashed gray',
    cursor: 'pointer',
  },
  fileUploadText: {
    fontSize: '1.5rem',
  },
});
